import { render, staticRenderFns } from "./create-v3.vue?vue&type=template&id=8bb62e78&"
import script from "./create-v3.vue?vue&type=script&lang=js&"
export * from "./create-v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports